import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BeeAlertComponent } from './bee-alert.component';

@NgModule({
  declarations: [
    BeeAlertComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BeeAlertComponent
  ]
})
export class BeeAlertModule { }
